// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

import wixWindow from 'wix-window';
import wixAnimations from 'wix-animations';
var c = 0;
var imgArray1 = [];
var imgArray2 = [];
var animeSet = [];
var blurbSet = [];
var animeCount = 0;
var t = 1200;
var initRun = true;

var theWin = wixWindow.formFactor;

$w.onReady(function () {
	blurbSet = [$w('#image12'), $w('#image13'),$w('#image14'), $w('#image15')];
	animeSet = [$w('#image1'), $w('#image2'), $w('#image3'), blurbSet[0], $w('#image4'), $w('#image5'), $w('#image6'), blurbSet[1], $w('#image7'), $w('#image8'), $w('#image9'), $w('#image10'), $w('#image11'), blurbSet[2], blurbSet[3]];
	
	
	if(theWin === 'Desktop'){
		initHide(animeSet);
		initHide(blurbSet);
		showHide(animeSet[0], 'show', 0);
		setTimeout(function(){
			animateSequence();
			initRun = false;	
		}, 1200);
	}
	
	audioFunc();
});

function initHide (_array) {
	for(var i = 1; i < _array.length; i ++){
		_array[i].hide();
	}
}
function showHide (_e, _s, _d) {
	var tl = wixAnimations.timeline({});
	
	setTimeout(function(){
		if(_s == 'show'){
			tl.add(_e, {
				"opacity":1,
				"duration":500,
				"easing":"easeOutCubic"
			})

			tl.play();
		} else {
			tl.add(_e, {
				"opacity":0,
				"duration":500,
				"easing":"easeOutCubic"
			})

			tl.play();
		}
	}, _d);
}

function animateSequence(){
	if(initRun === true){
		showHide(animeSet[1], 'show', 0 * t);
		showHide(animeSet[2], 'show', 0 * t);
		showHide(animeSet[3], 'show', 0 * t);
		showHide(animeSet[4], 'show', 0 * t);
		showHide(animeSet[5], 'show', 0 * t);
		showHide(animeSet[6], 'show', 0 * t);
		showHide(animeSet[7], 'show', 0 * t);
		showHide(animeSet[1], 'hide', 2 * t);
		showHide(animeSet[8], 'show', 2 * t);
		showHide(animeSet[2], 'hide', 3 * t);
		showHide(animeSet[9], 'show', 3 * t);
		showHide(animeSet[5], 'hide', 4 * t);
		showHide(animeSet[10], 'show', 4 * t);
		showHide(animeSet[4], 'hide', 5 * t);
		showHide(animeSet[11], 'show', 5 * t);
		showHide($w("#image16"), 'show', 5 * t);
		showHide(animeSet[3], 'hide', 5 * t);	
		showHide(animeSet[6], 'hide', 6 * t);
		showHide(animeSet[12], 'show', 6 * t);
		// showHide(animeSet[3], 'hide', 7 * t);
		showHide(animeSet[13], 'show', 7 * t);
		showHide(animeSet[7], 'hide', 8 * t);
		showHide(animeSet[14], 'show', 8 * t);
		showHide($w("#image16"), 'hide', 8 * t);

		setTimeout(animateSequence, 9 * t);

	}else{
		showHide(animeSet[8], 'hide', 0 * t);
		showHide(animeSet[1], 'show', 0 * t);
		showHide(animeSet[9], 'hide', 1 * t);
		showHide(animeSet[2], 'show', 1 * t);
		showHide(animeSet[10], 'hide', 2 * t);
		showHide(animeSet[3], 'show', 2 * t);
		showHide(animeSet[14], 'hide', 2 * t);
		showHide($w("#image16"), 'hide', 2 * t);
		showHide(animeSet[13], 'hide', 3 * t);
		showHide(animeSet[4], 'show', 3 * t);
		showHide(animeSet[11], 'hide', 4 * t);
		showHide(animeSet[5], 'show', 4 * t);
		showHide(animeSet[12], 'hide', 5 * t);
		showHide(animeSet[6], 'show', 5 * t);
		showHide(animeSet[14], 'hide', 6 * t);
		showHide(animeSet[7], 'show', 6 * t);
		showHide(animeSet[1], 'hide', 7 * t);
		showHide(animeSet[8], 'show', 7 * t);
		showHide(animeSet[2], 'hide', 8 * t);
		showHide(animeSet[9], 'show', 8 * t);
		showHide(animeSet[5], 'hide', 9 * t);
		showHide(animeSet[10], 'show', 9 * t);
		showHide(animeSet[4], 'hide', 10 * t);
		showHide(animeSet[11], 'show', 10 * t);
		showHide($w("#image16"), 'show', 10 * t);
		showHide(animeSet[3], 'hide', 10 * t);
		showHide(animeSet[6], 'hide', 11 * t);
		showHide(animeSet[12], 'show', 11 * t);
		showHide(animeSet[13], 'show', 12 * t);
		showHide(animeSet[7], 'hide', 13 * t);
		showHide(animeSet[14], 'show', 13 * t);
		showHide($w("#image16"), 'hide', 13 * t);

		setTimeout(animateSequence, 14 * t);
	}
}

function audioFunc(){
	$w("#audioPlayer1").onPlay( (event) => {
		$w('#audioIconOFF').hide();
		$w('#audioIconON').show();
		console.log('on');
	});

	$w("#audioPlayer1").onPause( (event) => {
		$w('#audioIconOFF').show();
		$w('#audioIconON').hide();
		console.log('off');
	})
}
